class DocumentationGoUp {

    constructor() {
        this.defaultRightScreenSeparation = 15;
        this.defaultScrollToShowButton = 250;
        this.defaultTimeToDissapearButton = 1000;
        this.defaultFadeInOutAnimationTime = 500;
        this.visibleButton = false;
        this.inactiveScrollTime = null;
    }

    setButtonStyle(folderId) {
        const goUpButtonIcon = $('#float-button-go-up-canvas-' + folderId);
        const goUpButton = $('#float-button-go-up-' + folderId);

        tintImage(goUpButtonIcon.attr('id'), goUpButtonIcon.attr('data-icon'), world.theme.color_1);
        goUpButton.css('border', '2px solid #' + world.theme.color_1);

    }

    setButtonPosition(folderId, rePositionOnResize) {
        const that = this;
        const goUpButton = $('#float-button-go-up-' + folderId);
        const appWrapper = $('.wrapper').last();
        let rightScreenPosition = this.defaultRightScreenSeparation;

        if ($(window).width() >= 1280) {
            const gapSize = 50; //css grid gap
            const emptyGrid = document.querySelector('.grid__blank__2');

            if(emptyGrid) {
                const {width} = emptyGrid.getBoundingClientRect() || 0;

                rightScreenPosition = width + this.defaultRightScreenSeparation + gapSize;
            }
        } else if ($(window).width() > appWrapper.width()) {
            rightScreenPosition = (($(window).width() - appWrapper.width()) / 2) + this.defaultRightScreenSeparation;
        }

        if (rePositionOnResize) {

            $(window).off('resize.floatButtonGoUp').on('resize.floatButtonGoUp', function () {
                that.setButtonPosition(folderId, false)
            });

        }

        goUpButton.css('right', rightScreenPosition + 'px');
    }

    showButton(folderId) {
        const goUpButton = $('#float-button-go-up-' + folderId);

        goUpButton.fadeTo(this.defaultFadeInOutAnimationTime, 1, function () {
            goUpButton.show()
        });

        this.visibleButton = true;

        $(document)
            .off('click.documentationGoUpButton')
            .on('click.documentationGoUpButton', '#float-button-go-up-' + folderId, function () {
                document
                    .querySelector('#documentation-documents li')
                    .scrollIntoView({behavior: 'smooth'})

                // window.scrollTo(0, 0);
            });
    }

    hideButton(folderId) {
        const goUpButton = $('#float-button-go-up-' + folderId);

        goUpButton.fadeTo(this.defaultFadeInOutAnimationTime, 0, function () {
            goUpButton.hide()
        });

        this.visibleButton = false;
    }

    manageGoUpButtonStatus(folderId) {
        const that = this;
        let doScroll;

        if ($(window).width() > 1280) {

            if(document.querySelector('#documentation-documents')) {
                const doc = document.querySelector('#documentation-documents');

                if(doc) {
                    const {y} = doc.getBoundingClientRect();
                    doScroll = Math.abs(y) >= this.defaultScrollToShowButton;
                }
            }
        } else {
            doScroll = $(window).scrollTop() >= this.defaultScrollToShowButton;
        }

        if (doScroll) {
            clearTimeout(this.inactiveScrollTime);

            this.inactiveScrollTime = setTimeout(function () {
                that.hideButton(folderId);
            }, this.defaultTimeToDissapearButton);

            if (!this.visibleButton) {
                this.showButton(folderId);
            }

            return;
        }

        if (this.visibleButton) {
            this.hideButton(folderId);
        }
    }

}
